import Axios from "axios";
import { ApiBaseUrl, ChequeBaseUrl } from "../config/config";
import {
  Filter,
  GetChequeRequest,
  GetChequeResponse,
} from "../models/cheque.model";
import { ApiResultModel } from "../models/common.model";

export const GetCheques = (
  data: GetChequeRequest
): Promise<ApiResultModel<GetChequeResponse[]>> => {
  return Axios.post<ApiResultModel<GetChequeResponse[]>>(
    ApiBaseUrl + ChequeBaseUrl + "/GetCheques",
    data
  ).then((result) => {
    return result.data;
  });
};

export const GetChequesExportToExcel = async (data: Filter) => {
  return await Axios({
    method: "POST",
    url: ApiBaseUrl + ChequeBaseUrl + "/GetChequesExportToExcel",
    data,
    responseType: "blob",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/pdf",
    },
  }).then((response: any) => {
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `${"چک ها"} .xlsx`);
    document.body.appendChild(link);
    link.click();
  });
};
